import { TRANSITION_IMAGE_DELAY, TRANSITION_LINES_DELAY } from '../configs';

export function getTransitionDelay(order: number, appearanceDelay: number): string {
  return `${appearanceDelay + TRANSITION_IMAGE_DELAY + TRANSITION_LINES_DELAY * order}ms`;
}
